// import React, { useEffect, useRef, useState } from "react";
// import { ShinyText } from "./Home";
// import student from "../../Asset/students.png";
// import BusinessProfessionals from "../../Asset/Business Professionals.png";
// import HealthcareProfessionals from "../../Asset/Healthcare Professionals.png";
// import ContentCreators from "../../Asset/content creators.png";
// import everyOneCover from "../../Asset/FOR EVERYONE.png";
// import legalAdvisorCover from "../../Asset/LEGAL ADVISOR.png";
// import { useInView } from "react-intersection-observer";
// const tabs = [
//   {
//     name: "For Everyone",
//     contentData: {
//       label: "For Everyone",
//       heading: "All-in-One Pocket.",
//       summary:
//         "From quick messages to AI-powered answers, ZeroTyping makes everyday typing faster, easier, and hands-free.",
//       media:
//         "https://res.cloudinary.com/etresources/video/upload/v1756379470/FOR_EVERY_ONE_i2l8vh.mp4",
//       coverImage: everyOneCover,
//       mediaType: "video",
//       style: "",
//       videoStyle: "relative -bottom-8",
//     },
//   },
//   {
//     name: "Education",
//     contentData: {
//       label: "Students",
//       heading: "Study Smarter, Not Harder.",
//       summary:
//         "Take notes, translate lectures, and ask GPT for instant explanations—all with just your voice.",
//       media: student,
//       mediaType: "image",
//       style: " w-[90%] relative -bottom-4 left-0",
//     },
//   },
//   {
//     name: "Business",
//     contentData: {
//       label: "Business Professionals",
//       heading: "Boost Your Productivity, Minimize Typing.",
//       summary:
//         "Draft emails, format documents, and communicate seamlessly across languages while staying focused on your work.",
//       media: BusinessProfessionals,
//       mediaType: "image",
//       style: "w-[80%] relative bottom-2 left-0",
//     },
//   },
//   {
//     name: "Healthcare",
//     contentData: {
//       label: "Healthcare Professionals",
//       heading: "Dictate medical notes with precision",
//       summary:
//         "Dictate medical notes, create accurate records, and translate patient interactions without ever touching a keyboard.",
//       media: HealthcareProfessionals,
//       mediaType: "image",
//       style: "w-[80%] relative ml-auto bottom-5",
//     },
//   },
//   {
//     name: "Law Practice",
//     contentData: {
//       label: "Law Practice",
//       heading: "Draft Legal Documents Without Lifting a Finger",
//       summary:
//         "Transcribe meetings, draft contracts, and ensure every word is precise with custom dictionaries and AI assistance.",
//       media:
//         "https://res.cloudinary.com/etresources/video/upload/v1756369330/LEGAL_ADVISOR_yxbahn.mp4",
//       coverImage: legalAdvisorCover,
//       mediaType: "video",
//       style: " relative -bottom-8 ",
//       videoStyle: " -bottom-8",
//     },
//   },
//   {
//     name: "Media",
//     contentData: {
//       label: "Content Creators",
//       heading: "Create Content Faster, with Flawless Accuracy",
//       summary:
//         "Brainstorm ideas, generate scripts, or clean up your text—Zero Typing helps you create faster with nothing but your voice.",
//       media: ContentCreators,
//       mediaType: "image",
//       style: " relative top-0 object-top  ",
//     },
//   },
// ];

// const UseCases = () => {
//   const [activeTab, setActiveTab] = useState(tabs[0].name);
//   const [indicatorStyle, setIndicatorStyle] = useState({});
//   const tabContainerRef = useRef(null);
//   const contentContainerRef = useRef(null);
//   const { ref, inView } = useInView({
//     triggerOnce: true,
//     threshold: 0.5,
//   });

//   useEffect(() => {
//     const activeButton = tabContainerRef.current.querySelector(
//       `button[data-tab="${activeTab}"]`
//     );
//     if (activeButton && inView) {
//       setIndicatorStyle({
//         width: activeButton.offsetWidth,
//         left: activeButton.offsetLeft,
//       });

//       activeButton.scrollIntoView({
//         behavior: "smooth",
//         inline: "center",
//         block: "nearest",
//       });
//     }

//     const activeContent = contentContainerRef.current.querySelector(
//       `div[data-content="${activeTab}"]`
//     );
//     if (activeContent && inView) {
//       activeContent.scrollIntoView({
//         behavior: "smooth",
//         inline: "center",
//         block: "nearest",
//       });
//     }
//   }, [activeTab, inView]);
//   return (
//     <div className=" flex flex-col xl:gap-10 lg:gap-8 md:gap-6 gap-4">
//       <div className="flex flex-col xl:gap-6 lg:gap-5 gap-4">
//         <div className="xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] tracking-tighter leading-tight font-bold  text-center font-jakarta ">
//           <span>AI Typing For </span>
//           <ShinyText
//             text="Everyone"
//             speed={5}
//             className="custom-class text-wrap"
//           />
//         </div>
//         <div className=" text-center font-medium xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] font-inter text-[#00000099]">
//           Zero Typing AI makes writing easy for everybody, so you{" "}
//           <br className=" hidden md:flex" /> can focus on what really matters.
//         </div>
//       </div>

//       <div
//         ref={(el) => {
//           tabContainerRef.current = el;
//           ref(el);
//         }}
//         className="relative flex justify-evenly gap-2 items-center overflow-x-auto overflow-hidden md:bg-[#F1F1F1] md:rounded-full md:p-4 lg:w-[80%] md:w-[95%] w-full mx-auto scrollbar-hide"
//       >
//         {/* Sliding Indicator */}
//         <span
//           className="absolute top-2 bottom-2 md:flex hidden bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] rounded-full shadow transition-all duration-300"
//           style={{
//             width: indicatorStyle.width,
//             left: indicatorStyle.left,
//           }}
//         ></span>

//         {tabs.map((tab) => (
//           <button
//             key={tab.name}
//             data-tab={tab.name}
//             onClick={() => setActiveTab(tab.name)}
//             className={`relative z-10 md:px-5 px-6 md:py-1 py-3 w-full md:bg-transparent rounded-full  md:text-sm text-xs  tracking-tighter  font-jakarta transition-colors whitespace-nowrap ${
//               activeTab === tab.name
//                 ? "text-white font-bold bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]  md:bg-none md:bg-transparent"
//                 : "text-[#00000099] font-medium bg-[#EBF7FE] md:bg-transparent"
//             }`}
//           >
//             {tab.name}
//           </button>
//         ))}
//       </div>
//       {/* Horizontal Content Row */}
//       <div className="relative w-full  tracking-[-0.01em]">
//         <div
//           ref={contentContainerRef}
//           className="  flex w-full gap-4 p-4  xl:px-20 lg:px-16 md:px-12 px-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory"
//         >
//           <div className=" md:flex hidden h-full z-50 w-[100px] left-0 top-0 bottom-0  absolute bg-gradient-to-l to-[#fff] from-transparent pointer-events-none"></div>
//           <div className=" md:flex hidden h-full z-50 w-[100px] right-0 top-0 bottom-0  absolute bg-gradient-to-r to-[#fff] from-transparent pointer-events-none"></div>

//           {tabs.map((tab) => (
//             <div
//               key={tab.name}
//               data-content={tab.name}
//               className={`md:w-[300px] w-[250px] border md:h-[510px] h-[450px] flex-shrink-0 snap-center flex flex-col gap-3 overflow-hidden rounded-xl transition-all ${
//                 activeTab === tab.name
//                   ? "bg-[#DFF2FD]  border-[#3AB1F6]"
//                   : "bg-white border-[#0000001A]"
//               }`}
//             >
//               <div className=" flex flex-col md:gap-3 gap-2 p-4">
//                 <h3
//                   className={`text-[10px] py-2 px-6 rounded-lg font-jakarta w-max ${
//                     activeTab === tab.name
//                       ? "bg-gradient-to-r font-bold from-[#3AB1F6] to-[#407BFF]"
//                       : "bg-[#979797] font-semibold"
//                   } text-white`}
//                 >
//                   {tab.contentData.label}
//                 </h3>
//                 <div className=" flex flex-col gap-2">
//                   <h1 className={` text-lg font-bold font-jakarta`}>
//                     {tab.contentData.heading}
//                   </h1>
//                   <p className=" text-xs font-inter text-[#00000099]">
//                     {tab.contentData.summary}
//                   </p>
//                 </div>
//               </div>
//               {tab.contentData.mediaType === "image" ? (
//                 <img
//                   src={tab.contentData.media}
//                   className={`${tab.contentData.style}`}
//                   alt=""
//                 />
//               ) : (
//                 <div>
//                   {activeTab === tab.name ? (
//                     <div
//                       className={`w-full relative ${tab?.contentData?.videoStyle} overflow-hidden`}
//                     >
//                       <div className=" h-[25px] w-full top-0 right-0 left-0 absolute bg-gradient-to-t to-[#DFF2FD] from-transparent"></div>
//                       {tab?.name === "For Everyone" && (
//                         <div className=" h-[25px] w-full bottom-0 right-0 left-0 absolute bg-gradient-to-b to-[#DFF2FD] from-transparent"></div>
//                       )}

//                       <video
//                         className={`w-full  mx-auto `}
//                         src={tab.contentData.media}
//                         autoPlay
//                         loop
//                         muted
//                         playsInline
//                         webkit-playsinline="true"
//                         preload="metadata"
//                       />
//                     </div>
//                   ) : (
//                     <img
//                       src={tab.contentData.coverImage}
//                       className={`${tab.contentData.style}`}
//                       alt=""
//                     />
//                   )}
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UseCases;

import React, { useEffect, useRef, useState } from "react";
import { ShinyText } from "./Home";
import student from "../../Asset/students.png";
import BusinessProfessionals from "../../Asset/Business Professionals.png";
import HealthcareProfessionals from "../../Asset/Healthcare Professionals.png";
import ContentCreators from "../../Asset/content creators.png";
import everyOneCover from "../../Asset/FOR EVERYONE.png";
import legalAdvisorCover from "../../Asset/LEGAL ADVISOR.png";
import { useInView } from "react-intersection-observer";

const tabs = [
  {
    name: "For Everyone",
    contentData: {
      label: "For Everyone",
      heading: "All-in-One Pocket.",
      summary:
        "From quick messages to AI-powered answers, ZeroTyping makes everyday typing faster, easier, and hands-free.",
      media:
        "https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/USE%20CASE%201.mp4",
      coverImage: everyOneCover,
      mediaType: "video",
      style: "",
      videoStyle: "relative -bottom-8",
    },
  },
  {
    name: "Education",
    contentData: {
      label: "Students",
      heading: "Study Smarter, Not Harder.",
      summary:
        "Take notes, translate lectures, and ask GPT for instant explanations—all with just your voice.",
      media: student,
      mediaType: "image",
      style:
        " sm:w-[90%] 2xl:w-[85%] w-[87%] relative 2xl:bottom-2 sm:-bottom-3 md:-bottom-4 2xl:bottom-7 bottom-1 left-0",
    },
  },
  {
    name: "Business",
    contentData: {
      label: "Business Professionals",
      heading: "Boost Your Productivity, Minimize Typing.",
      summary:
        "Draft emails, format documents, and communicate seamlessly across languages while staying focused on your work.",
      media: BusinessProfessionals,
      mediaType: "image",
      style: "2xl:w-[98%] w-[95%] relative bottom-2  left-0 2xl:top-[-35px]",
    },
  },
  {
    name: "Healthcare",
    contentData: {
      label: "Healthcare Professionals",
      heading: "Dictate medical notes with precision",
      summary:
        "Dictate medical notes, create accurate records, and translate patient interactions without ever touching a keyboard.",
      media: HealthcareProfessionals,
      mediaType: "image",
      style: "2xl:w-[98%] lg:w-[100%] w-[99%] relative ml-auto bottom-5",
    },
  },
  {
    name: "Law Practice",
    contentData: {
      label: "Law Practice",
      heading: "Draft Legal Documents Without Lifting a Finger",
      summary:
        "Transcribe meetings, draft contracts, and ensure every word is precise with custom dictionaries and AI assistance.",
      media:
        "https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/USE%20CASE%20LEGAL%20.mp4",
      coverImage: legalAdvisorCover,
      mediaType: "video",
      style: " relative -bottom-10 ",
      videoStyle: " 2xl:-bottom-2 md:-bottom-10 -bottom-8",
    },
  },
  {
    name: "Media",
    contentData: {
      label: "Content Creators",
      heading: "Create Content Faster, with Flawless Accuracy",
      summary:
        "Brainstorm ideas, generate scripts, or clean up your text—Zero Typing helps you create faster with nothing but your voice.",
      media: ContentCreators,
      mediaType: "image",
      style: " relative  object-top bottom-5 ",
    },
  },
];

/** ---------- horizontal-only helper ---------- */
function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

function scrollChildIntoViewX(container, child, { center = true } = {}) {
  if (!container || !child) return;

  const containerRect = container.getBoundingClientRect();
  const childRect = child.getBoundingClientRect();

  const currentLeft = container.scrollLeft;
  const childLeftInScroll = currentLeft + (childRect.left - containerRect.left);

  let targetLeft;
  if (center) {
    targetLeft =
      childLeftInScroll - (container.clientWidth - child.clientWidth) / 2;
  } else {
    if (childLeftInScroll < currentLeft) {
      targetLeft = childLeftInScroll;
    } else if (
      childLeftInScroll + child.clientWidth >
      currentLeft + container.clientWidth
    ) {
      targetLeft =
        childLeftInScroll + child.clientWidth - container.clientWidth;
    } else {
      targetLeft = currentLeft;
    }
  }

  const maxLeft = container.scrollWidth - container.clientWidth;
  targetLeft = clamp(targetLeft, 0, Math.max(0, maxLeft));

  container.scrollTo({ left: targetLeft, behavior: "smooth" });
}

const UseCases = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].name);
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const tabContainerRef = useRef(null);
  const contentContainerRef = useRef(null);
  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  // guards for programmatic scroll & debounce
  const ignoreScrollRef = useRef(false);
  const scrollEndTimeoutRef = useRef(null);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  // Align indicator and horizontally center selected tab & card
  useEffect(() => {
    const tabContainer = tabContainerRef.current;
    if (!tabContainer) return;

    const activeButton = tabContainer.querySelector(
      `button[data-tab="${activeTab}"]`,
    );

    if (activeButton && inView) {
      setIndicatorStyle({
        width: activeButton.offsetWidth,
        left: activeButton.offsetLeft,
      });
      scrollChildIntoViewX(tabContainer, activeButton, { center: true });
    }

    const contentContainer = contentContainerRef.current;
    if (!contentContainer) return;

    const activeContent = contentContainer.querySelector(
      `div[data-content="${activeTab}"]`,
    );

    if (activeContent && inView) {
      ignoreScrollRef.current = true;
      scrollChildIntoViewX(contentContainer, activeContent, { center: true });
      const t = setTimeout(() => {
        ignoreScrollRef.current = false;
      }, 450);
      return () => clearTimeout(t);
    }
  }, [activeTab, inView]);

  // MOBILE: after scroll snapping ends, set activeTab to centered card
  useEffect(() => {
    const container = contentContainerRef.current;
    if (!container) return;

    const onScroll = () => {
      if (window.innerWidth >= 768) return; // mobile only
      if (ignoreScrollRef.current) return;

      if (scrollEndTimeoutRef.current)
        clearTimeout(scrollEndTimeoutRef.current);
      scrollEndTimeoutRef.current = setTimeout(() => {
        const rect = container.getBoundingClientRect();
        const containerCenterX = rect.left + rect.width / 2;

        const cards = Array.from(
          container.querySelectorAll("div[data-content]"),
        );
        if (!cards.length) return;

        let closestIdx = 0;
        let minDist = Infinity;

        cards.forEach((card, idx) => {
          const r = card.getBoundingClientRect();
          const cardCenterX = r.left + r.width / 2;
          const dist = Math.abs(cardCenterX - containerCenterX);
          if (dist < minDist) {
            minDist = dist;
            closestIdx = idx;
          }
        });

        const name = tabs[closestIdx].name;
        if (name !== activeTab) setActiveTab(name);
      }, 120);
    };

    container.addEventListener("scroll", onScroll, { passive: true });

    const onResize = () => {
      const btn = tabContainerRef.current?.querySelector(
        `button[data-tab="${activeTab}"]`,
      );
      if (btn) {
        setIndicatorStyle({
          width: btn.offsetWidth,
          left: btn.offsetLeft,
        });
      }
    };
    window.addEventListener("resize", onResize);

    return () => {
      container.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      if (scrollEndTimeoutRef.current)
        clearTimeout(scrollEndTimeoutRef.current);
    };
  }, [activeTab]);

  return (
    <div className="flex flex-col xl:gap-10 lg:gap-8 md:gap-6 gap-4 z-[5] bg-white">
      <div className="flex flex-col xl:gap-6 lg:gap-5 gap-4">
        <div
          ref={headingRef}
          className={`${
            headingView
              ? `animate-slideUp z-[3] anim-preserve`
              : "opacity-0 z-0"
          } xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] tracking-normal leading-tight font-bold text-center font-jakarta `}
        >
          <span>AI Typing For </span>
          <ShinyText
            text="Everyone"
            speed={5}
            className="custom-class text-wrap"
          />
        </div>
        <div className="text-center z-[4] relative bg-white xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] font-inter text-[#00000099]">
          Zero Typing AI makes writing easy for everybody, so you{" "}
          <br className="hidden md:flex" /> can focus on what really matters.
        </div>
      </div>

      <div
        ref={(el) => {
          tabContainerRef.current = el;
          ref(el);
        }}
        className="relative flex justify-evenly gap-2 items-center overflow-x-auto overflow-hidden md:bg-[#F1F1F1] md:rounded-full md:p-4 lg:w-[80%] md:w-[95%] w-full mx-auto scrollbar-hide"
      >
        {/* Sliding Indicator (desktop/tablet only) */}
        <span
          className="absolute top-2 bottom-2 md:flex hidden bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]  rounded-full shadow transition-all duration-300"
          style={{
            width: indicatorStyle.width,
            left: indicatorStyle.left,
          }}
        ></span>

        {tabs.map((tab) => (
          <button
            key={tab.name}
            data-tab={tab.name}
            onClick={() => setActiveTab(tab.name)}
            className={`relative z-10 md:px-5 px-6 md:py-1 py-3 w-full md:bg-transparent rounded-full md:text-sm text-xs tracking-normal font-jakarta transition-colors whitespace-nowrap ${
              activeTab === tab.name
                ? "text-white font-bold bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]  md:bg-none md:bg-transparent"
                : "text-[#00000099] font-medium bg-[#EBF7FE] md:bg-transparent"
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {/* Horizontal Content Row */}
      <div className="relative w-full tracking-[-0.01em]">
        <div
          ref={contentContainerRef}
          className={
            "flex w-full gap-4 p-4 xl:px-20 lg:px-16 md:px-12 px-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory"
          }
        >
          <div className="md:flex hidden h-full z-50 w-[100px] left-0 top-0 bottom-0 absolute bg-gradient-to-l to-[#fff] from-transparent pointer-events-none"></div>
          <div className="md:flex hidden h-full z-50 w-[100px] right-0 top-0 bottom-0 absolute bg-gradient-to-r to-[#fff] from-transparent pointer-events-none"></div>

          {tabs.map((tab) => (
            <div
              key={tab.name}
              data-content={tab.name}
              className={`md:w-[300px] 2xl:w-[400px] w-[250px] border 2xl:h-[600px] md:h-[510px] h-[450px] flex-shrink-0 snap-center flex flex-col gap-3 overflow-hidden rounded-xl transition-all ${
                activeTab === tab.name
                  ? "bg-[#DFF2FD] border-[#3AB1F6]"
                  : "bg-white border-[#0000001A]"
              }`}
            >
              <div className="flex flex-col md:gap-3 gap-2 p-4">
                <h3
                  className={`2xl:text-sm text-xs py-2 px-6 rounded-lg leading-none font-jakarta w-max ${
                    activeTab === tab.name
                      ? "bg-gradient-to-r font-bold from-[#3AB1F6] to-[#407BFF]"
                      : "bg-[#979797] font-semibold"
                  } text-white`}
                >
                  {tab.contentData.label}
                </h3>
                <div className="flex flex-col gap-2">
                  <h1 className="text-lg 2xl:text-xl font-bold leading-tight font-jakarta">
                    {tab.contentData.heading}
                  </h1>
                  <p className="text-xs 2xl:text-sm font-inter text-[#00000099]">
                    {tab.contentData.summary}
                  </p>
                </div>
              </div>

              {tab.contentData.mediaType === "image" ? (
                <img
                  src={tab.contentData.media}
                  className={tab.contentData.style}
                  alt=""
                />
              ) : (
                <div>
                  {activeTab === tab.name ? (
                    <div
                      className={`w-full relative ${
                        tab?.contentData?.videoStyle || ""
                      } overflow-hidden`}
                    >
                      <div className="h-[25px] w-full top-0 right-0 left-0 absolute bg-gradient-to-t to-[#DFF2FD] from-transparent"></div>
                      {tab?.name === "For Everyone" && (
                        <div className="h-[25px] w-full bottom-0 right-0 left-0 absolute bg-gradient-to-b to-[#DFF2FD] from-transparent"></div>
                      )}

                      <video
                        className="w-full mx-auto"
                        src={tab.contentData.media}
                        autoPlay
                        loop
                        muted
                        playsInline
                        preload="metadata"
                      />
                    </div>
                  ) : (
                    <img
                      src={tab.contentData.coverImage}
                      className={tab.contentData.style}
                      alt=""
                    />
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UseCases;
